import { NavLink } from 'react-router-dom';
import './Card.css';

const Card = (props) => {
    return (

        <div className="flip-card">
            <div className="flip-card-inner">
                <div className="flip-card-front p-10" style={{ backgroundImage: "https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain" }}>
                    {/* <!-- Front content --> */}
                    <h2>{props.content.header}</h2>
                    {
                        props.content.description && props.content.description.length !== 0 ?
                            <img src={`${props.content.description}`} alt="" height={'100%'} width={'90%'} /> :
                            <div dangerouslySetInnerHTML={{ __html: props.content.body }} />
                    }
                    <p>Hover over me!</p>
                </div>
                <div className="flip-card-back p-10">
                    {/* <!-- Back content --> */}
                    {
                        props.content.description && props.content.description.length !== 0 ? <p className='p-10' dangerouslySetInnerHTML={{ __html: props.content.body }} /> : <></>
                    }
                    {/* <p>Additional details here.</p> */}
                    <NavLink className={'color-white'} to={`/read/${props.content._id}`}>
                        Read more...
                    </NavLink>
                </div>
            </div>
        </div>

    )
}

export default Card;

